<template>
    <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
        <slot />
    </transition>
</template>

<script lang="js">
export default {
    name: "TransitionExpand",
    methods: {
        enter(element) {
            const width = getComputedStyle(element).width

            element.style.width = width
            element.style.position = "absolute"
            element.style.visibility = "hidden"
            element.style.height = "auto"

            const height = getComputedStyle(element).height

            element.style.width = null
            element.style.position = null
            element.style.visibility = null
            element.style.height = 0

            // Force repaint to make sure the
            // animation is triggered correctly.
            getComputedStyle(element).height

            // Trigger the animation.
            // We use `requestAnimationFrame` because we need
            // to make sure the browser has finished
            // painting after setting the `height`
            // to `0` in the line above.
            requestAnimationFrame(() => {
                element.style.height = height
            })
        },

        afterEnter(element) {
            element.style.height = "auto"
        },

        leave(element) {
            const height = getComputedStyle(element).height

            element.style.height = height

            // Force repaint to make sure the
            // animation is triggered correctly.
            getComputedStyle(element).height

            requestAnimationFrame(() => {
                element.style.height = 0
            })
        },
    },
}
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
    /* Warning: 200 ms equals 0.2 seconds; the latter value is hardcoded into the component
    CartItems' method scrollElementIntoView, hence they must match!! IMPTODO: Make them match automatically */
    transition: height 0.2s ease-in-out;
    overflow: hidden;
}

.expand-enter,
.expand-leave-to {
    height: 0;
}

* {
    will-change: height;
    transform: translateZ(0);
    backface-visibility: hidden;
    perspective: 1000px;
}
</style>
